import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const ContainerKehilati = styled.div`
  grid-area: ${(props) => props.$gridArea || "3 / 1 / 3 / 5"};
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
  color: #2d3653;
  font-family: "IBM Plex Sans JP", sans-serif;

  @media (max-width: 768px) {
    flex-direction: ${(p) => (p.$keepRowOnMobile ? "row" : "column")};
    flex-wrap: ${(p) => (p.$keepRowOnMobile ? "wrap" : "nowrap")};
    justify-content: ${(p) => (p.$keepRowOnMobile ? "center" : undefined)};
    text-align: ${(p) => (p.$keepRowOnMobile ? "inherit" : "center")};
  }
`;

/** Compact, vertical, bas-droite (ex. LayoutRenderer TV) */
const ContainerKehilatiDock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 0;
  padding: 4px 6px;
  color: #2d3653;
  font-family: "IBM Plex Sans JP", sans-serif;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  max-height: min(42vh, 300px);
`;

const Row = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: row;
  align-items: center;
`;

const RowDock = styled(Row)`
  gap: 6px;
`;

const Link = styled.a`
  text-decoration: none;
  display: flex;
`;

const Logo = styled.img`
  height: 30px;
  width: auto;
`;

const LogoDock = styled(Logo)`
  display: block;
  height: 22px;
  width: auto;
  transform: rotate(90deg);
  transform-origin: center center;
`;

const TextDock = styled.span`
  font-size: 10px;
  line-height: 1.2;
  height: 75px;
`;

const KehilatiContainer = ({
  logoPath = "/images/kehilati.png",
  websiteUrl = "https://kehilati.com",
  gridArea,
  variant = "default",
  keepHorizontalOnMobile = false,
}) => {
  const { t } = useTranslation();

  if (variant === "layoutDock") {
    return (
      <ContainerKehilatiDock>
        <RowDock>
          <TextDock>{t("kehilati.madeBy")}</TextDock>
          <Link href={websiteUrl} target="_blank" rel="noopener noreferrer">
            <LogoDock src={logoPath} alt="Kehilati" />
          </Link>
        </RowDock>
      </ContainerKehilatiDock>
    );
  }

  return (
    <ContainerKehilati
      $gridArea={gridArea || "3 / 1 / 3 / 5"}
      $keepRowOnMobile={keepHorizontalOnMobile}
    >
      <Row>
        {t("kehilati.madeBy")}
        <Link href={websiteUrl} target="_blank" rel="noopener noreferrer">
          <Logo src={logoPath} alt="Kehilati" />
        </Link>
      </Row>
    </ContainerKehilati>
  );
};

export default KehilatiContainer;
